import { render, staticRenderFns } from "./WordpressGuideModal.vue?vue&type=template&id=e43016f8&scoped=true&"
var script = {}
import style0 from "./WordpressGuideModal.vue?vue&type=style&index=0&id=e43016f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e43016f8",
  null
  
)

export default component.exports